window.Vue = require('vue').default;

import VueRouter from 'vue-router'
import FulfillmentList from './FulfillmentLegacy/vue/fulfillment-list.vue'
import FulfillmentNew from './FulfillmentLegacy/vue/fulfillment-new.vue'
import FulfillmentDetail from './FulfillmentLegacy/vue/fulfillment-detail.vue'

Vue.use(VueRouter)

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

Vue.component('btn', require('./../common/vue/btn.vue').default);
Vue.component('sorting-header', require('./../common/vue/sorting-header.vue').default);
Vue.component('t2t-master', require('./UI/vue/master.vue').default);

if ($('#jobadviser').length) {
    Window.instanceId = uuidv4();

    const routes = [
        { path: '/admin/driver-engage/fulfillment', name: 'fulfilment-list', component: FulfillmentList },
        { path: '/admin/driver-engage/fulfillment/new', name: 'fulfilment-new', component: FulfillmentNew },
        { path: '/admin/driver-engage/fulfillment/:fulfillment_id', name: 'fulfilment-detail', component: FulfillmentDetail, props: true },
    ];
    
    const router = new VueRouter({
        mode: 'history',
        routes
    });

    const jobadviser = new Vue({
        router
    }).$mount('#jobadviser');
}
